export default "__VITE_ASSET__DxHfDzh$__"